import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const MuktinathTour = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO BANNER */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage:
            "url('/Images/tour/muktinath-darshan-banner.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Muktinath Darshan Yatra</h1>

            <p className="hero-subtitle">
              5 Nights / 6 Days • Sacred Muktinath Pilgrimage
            </p>

            <div className="hero-price">
              Starting From <span>₹38,999</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + FORM */}
        <Row className="mb-4">

          {/* LEFT SLIDER */}
          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/muktinath-darshan-banner.jpg" alt="" />
                <img src="/Images/tour/muktinath-darshan-banner1.png" alt="" />
                <img src="/Images/tour/muktinath-darshan-banner3.webp" alt="" />
              </Slider>
            </div>
          </Col>

          {/* RIGHT FORM */}
          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹38,999</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Muktinath Darshan Yatra</h1>
              <p>5 Nights / 6 Days • Muktinath Spiritual Tour</p>
            </div>

            {/* Highlights */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Muktinath Temple Darshan</Col>
                <Col md={6}>✔ 108 Holy Water Spouts</Col>
                <Col md={6}>✔ Jomsom Scenic Journey</Col>
                <Col md={6}>✔ Pokhara Sightseeing</Col>
              </Row>
            </div>

            {/* Overview */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Embark on a divine pilgrimage to Muktinath Temple,
                one of the holiest destinations for Hindus and Buddhists.
                Located in the majestic Himalayas of Nepal, this journey
                combines spirituality, natural beauty and unforgettable
                mountain experiences.
              </p>
            </div>

            {/* Itinerary */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Kathmandu
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival in Kathmandu, hotel transfer and
                    evening Pashupatinath Temple Darshan.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Kathmandu to Pokhara
                  </Accordion.Header>
                  <Accordion.Body>
                    Drive or fly to Pokhara and enjoy lakeside
                    sightseeing and relaxation.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Pokhara to Jomsom
                  </Accordion.Header>
                  <Accordion.Body>
                    Scenic mountain flight/drive to Jomsom
                    followed by hotel transfer.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Muktinath Darshan
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Muktinath Temple, take holy bath at
                    108 water spouts and perform puja rituals.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Return Pokhara
                  </Accordion.Header>
                  <Accordion.Body>
                    Return journey to Pokhara with leisure
                    evening and sightseeing.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    Day 6 – Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    Breakfast and transfer for onward journey
                    with divine blessings.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* Inclusion / Exclusion */}
            <div className="content-box">
              <Row>

                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul className="inclusion-list">
                    <li>Hotel Accommodation</li>
                    <li>Breakfast & Dinner</li>
                    <li>Airport Transfers</li>
                    <li>Muktinath Darshan Assistance</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul className="exclusion-list">
                    <li>Personal Expenses</li>
                    <li>Insurance</li>
                    <li>Lunch</li>
                    <li>Helicopter Charges (Optional)</li>
                  </ul>
                </Col>

              </Row>
            </div>

            {/* Gallery */}
            <div className="content-box">
              <h3>Gallery</h3>

              <Row className="gallery">
                <Col md={4}>
                  <img src="/Images/tour/muktinath-darshan-banner.jpg" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/muktinath-darshan-banner1.png" alt="" />
                </Col>
                <Col md={4}>
                  <img src="/Images/tour/muktinath-darshan-banner3.webp" alt="" />
                </Col>
              </Row>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default MuktinathTour;